/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Try_AgainInputs */

const en_admin_ai_chat_try_again = /** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

const de_admin_ai_chat_try_again = /** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const es_admin_ai_chat_try_again = /** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentar de nuevo`)
};

const fr_admin_ai_chat_try_again = /** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const nl_admin_ai_chat_try_again = /** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw proberen`)
};

/** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */
const it_admin_ai_chat_try_again = en_admin_ai_chat_try_again;

/** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_try_again = en_admin_ai_chat_try_again;

/** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */
const pl_admin_ai_chat_try_again = en_admin_ai_chat_try_again;

/** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */
const hu_admin_ai_chat_try_again = en_admin_ai_chat_try_again;

/** @type {(inputs: Admin_Ai_Chat_Try_AgainInputs) => LocalizedString} */
const ro_admin_ai_chat_try_again = en_admin_ai_chat_try_again;

/**
* | output |
* | --- |
* | "Try Again" |
*
* @param {Admin_Ai_Chat_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_try_again = /** @type {((inputs?: Admin_Ai_Chat_Try_AgainInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Try_AgainInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_try_again(inputs)
	if (locale === "de") return de_admin_ai_chat_try_again(inputs)
	if (locale === "es") return es_admin_ai_chat_try_again(inputs)
	if (locale === "fr") return fr_admin_ai_chat_try_again(inputs)
	if (locale === "nl") return nl_admin_ai_chat_try_again(inputs)
	if (locale === "it") return it_admin_ai_chat_try_again(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_try_again(inputs)
	if (locale === "pl") return pl_admin_ai_chat_try_again(inputs)
	if (locale === "hu") return hu_admin_ai_chat_try_again(inputs)
	return ro_admin_ai_chat_try_again(inputs)
});
export { admin_ai_chat_try_again as "admin.ai_chat.try_again" }